import WaveSurfer from "wavesurfer.js";

export class AudioPlayer {

    /**
     * Constructor
     */
    constructor() {
        this.isLoading = false;
        this.autoPlay = false;
    }

    /**
     * Initialize the player
     */
    initializePlayer() {

        // Create the player instance
        this.createPlayer();

        // Wire up the events
        this.waveSurfer.on(
            'audioprocess',
            () => this.updateState()
        );
        this.waveSurfer.on(
            'pause',
            () => this.updateState()
        );
        this.waveSurfer.on(
            'play',
            () => this.updateState()
        );
        this.waveSurfer.on(
            'seeking',
            () => this.updateState()
        );
        this.waveSurfer.on(
            'loading',
            (progress) => this.updateLoadingProgress(progress)
        );
        this.waveSurfer.on(
            'ready',
            (progress) => this.trackLoaded()
        );
        this.waveSurfer.on(
            'redraw',
            (progress) => this.trackLoaded()
        );

        // Load first track
        let firstTrack = document.querySelector('.ap-track-row:first-child .ap-play-track');
        this.load(firstTrack);
    }

    /**
     * Create the wave Surfer Player
     */
    createPlayer() {
        this.waveSurfer = WaveSurfer.create({
            container: '#waveForm',
            waveColor: '#444',
            progressColor: '#FFFFFF',
            cursorColor: '#FFFFFF',
            normalize: true,
            responsive: true,
            barWidth: 3,
            backend: 'MediaElement'
        });
    }

    /**
     * This is called as soon we are ready after loading
     */
    trackLoaded() {
        this.isLoading = false;
        this.updateState();
        if (this.autoplay)
            this.waveSurfer.play();
    }

    /**
     * Update the ui state of the player
     */
    updateState() {
        if (!this.isLoading) {
            this.updateDuration();
        }
        this.updateControls();
    }

    /**
     * Update the loading progress
     * @param progress
     */
    updateLoadingProgress(progress) {
        document.querySelector('.ap-track-playing-duration').innerHTML = progress + '%';
        document.querySelector('#ap-loading-bar > div').style.width = progress + '%';
        if (progress >= 100) {
            document.querySelector('#ap-loading-bar').style.opacity = 0;
        } else {
            document.querySelector('#ap-loading-bar').style.opacity = 100;
        }
    }

    /**
     * Update playtime
     */
    updateDuration() {
        let currentTime = this.waveSurfer.getCurrentTime();
        const hours = Math.floor(currentTime / 3600);
        currentTime -= hours * 3600;
        const minutes = Math.floor(currentTime / 60);
        currentTime -= minutes * 60;
        const seconds = Math.floor(currentTime / 1);
        document.querySelector('.ap-track-playing-duration').innerHTML = `${hours}:${('0' + minutes).slice(-2)}:${('0' + seconds).slice(-2)}`;
    }

    /**
     * Update the state of the controls
     */
    updateControls() {
        // Update Button State play or pause
        let controlButton = document.querySelector('.ap-control-big > i');
        if (this.waveSurfer.isPlaying()) {
            controlButton.classList.remove('oi-media-play', 'oi-media-stop');
            controlButton.classList.add('oi-media-pause');
        } else {
            controlButton.classList.remove('oi-media-pause', 'oi-media-stop');
            controlButton.classList.add('oi-media-play');
        }
    }

    /**
     * Update title and highlight selected row
     */
    updateTitle() {
        // Update the highlight row of selected track
        let activeRows = document.querySelectorAll('.ap-track-row.active')
        for (let i = 0; i < activeRows.length; i++) {
            activeRows[i].classList.remove('active');
        }
        this.selectedTrack.parentElement.classList.add('active');

        // Update track title
        document.querySelector('.ap-track-playing-title').innerHTML = this.selectedTrack.dataset.title;
    }

    /**
     * Just load a track, but do not start playing
     * @param track
     */
    load(track) {
        this.selectedTrack = track;
        this.isLoading = true;
        this.updateTitle();

        // Load the waveform first. If it fails, load the track directly.
        fetch(track.dataset.waveformUrl)
            .then((response) => response.json())
            .then((waveform) => {
                this.waveSurfer.load(
                    track.dataset.url,
                    waveform.data

                );
            })
            .catch(() => {
                this.waveSurfer.load(
                    track.dataset.url
                );
            });

    }

    /**
     * Play track on click
     * @param event
     */
    play(event) {
        event.preventDefault();
        let track = event.target;
        this.autoplay = true;
        this.load(track);
    }

    /**
     * Toggle the play state on click
     */
    toggle(event) {
        event.preventDefault();
        this.waveSurfer.playPause();
        this.updateControls();
    }

}
